import { useState, useEffect, useMemo } from 'react';
import { findGreatestWeightedMatch } from '../util/ArrayWorks';
import { getProductConfig } from '../config/products';
import propTypes from 'prop-types';
import configs from '../config/app';
import useSsoHook from './sso.hook';

/**
 * Fetches the Training Hub SSO link for a given customer and their subscriptions.
 * @param {string | number} customerId
 * @param {Array<Object>} subscriptions
 * @returns {{ hubLink: string, ready: boolean }} An object containing the Training Hub SSO link and its readiness status.
 */
export const useTrainingHubHook = (customerId, subscriptions, urlString = '') => {
  const [hubLink, setHubLink] = useState('');
  const [ready, setReady] = useState(false);
  const sessionProducts = useMemo(
    () => getProductConfig(configs.clientId, 'liveSessions') || [],
    []
  );
  const { token, ready: ssoReady } = useSsoHook(customerId);
  useEffect(() => {
    if (token && ssoReady && subscriptions?.length > 0 && customerId) {
      const serviceItem =
        findGreatestWeightedMatch(sessionProducts, subscriptions)?.shortCode || '';
      setHubLink(
        `https://${urlString || 'www.noa.training/sso-login'}?token=${token}&clientId=${configs.clientId}${serviceItem ? `&service=${serviceItem}` : ''}`
      );
      setReady(true);
    }
  }, [token, ssoReady, subscriptions, sessionProducts, customerId]);

  return { hubLink, ready };
};

useTrainingHubHook.propTypes = {
  customerId: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  subscriptions: propTypes.array.isRequired,
};
